import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage';

export default class Input extends PureComponent {
  render () {
    const { name, value, label, error, onChange, info, ...inputProps } = this.props;

    return (
      <div className='form-group'>
        <label>{label}</label>
        {info && (
          <div className='text-muted'>{info}</div>
        )}
        <input className='input' name={name} value={value} onChange={onChange} {...inputProps} />
        <ErrorMessage errorText={error} />
      </div>
    );
  }
}

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  info: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/forms/Input/index.js